import { render, staticRenderFns } from "./RegisterListPromotion.page.vue?vue&type=template&id=56405b1c&"
import script from "./RegisterListPromotion.page.vue?vue&type=script&lang=js&"
export * from "./RegisterListPromotion.page.vue?vue&type=script&lang=js&"
import style0 from "./RegisterListPromotion.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports